import cx from 'classnames'
import type React from 'react'

import IconArrowLeft from '../../icons/IconArrowLeft'
import css from './Notification.module.scss'
import type { Classnames, Props } from './types'

const Notification: React.FC<Props> = ({
  type,
  text,
  fixed,
  forModal,
  onClick,
  actionText,
  onClose,
}) => {
  const classes: Classnames = {
    container: cx(
      css.container,
      type && css[type],
      // fixed && animated && css.animated,
      fixed && css.fixed,
      fixed && forModal && css.forModal
    ),
  }

  const onClickAction = () => {
    onClick?.()
  }

  const handleOnClose = () => {
    onClose?.()
  }

  return (
    <div className={classes.container}>
      {type === 'ai' && <div className={css.aiBackground} />}
      <span>{text}</span>
      {onClick && !onClose && (
        <div className={css.action} onClick={onClickAction}>
          <IconArrowLeft size={12} />
          <span>{actionText}</span>
        </div>
      )}

      {onClose && !onClick && (
        <div className={css.action} onClick={handleOnClose}>
          <i className="fa fa-xmark" />
        </div>
      )}
    </div>
  )
}

export default Notification
